import React from 'react';

export default function(ComposedComponent, className, authRequired) {
    class BodyClassName extends React.Component {
        componentDidMount() {
            document.body.classList.toggle(className, !this.props.authenticated && authRequired);
        }

        componentWillReceiveProps(nextProps) {
            document.body.classList.toggle(className, !nextProps.authenticated && authRequired);
        }

        componentWillUnmount() {
            document.body.classList.toggle(className, false);
        }

        render() {
            return <ComposedComponent {...this.props} />
        }
    }

    return BodyClassName;
}


// WEBPACK FOOTER //
// ./src/components/HigherOrder/BodyClassName.js